import './LiveChart.scss'
import {Chart} from "react-chartjs-2";
import {options as defaultOptions} from "./_options.js";
import {useRef} from "react";
import Counter from "../../../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../../../util/numbers.js";
import LoaderCircle from "../../../util/loaders/LoaderCircle.jsx";
import SideBar from "./SideBar.jsx";
import {useLiveChartData} from "./useLiveChartData.js";
import {useDispatch} from "react-redux";
import {setLiveChartHoverIsInactive, setLiveChartHoverValues} from "../../../../ducks/live-chart-duck.js";
import CircleIcon from "mdi-react/CircleIcon.js";
import {isMobile} from "../../../../util/misc.js";

const durations = [
    1,
    3,
    6,
    12,
    24,
    24 * 7,
    !isMobile() && 24 * 30,
    !isMobile() && 24 * 90,
].filter(v=>v)
export default ({assetId}) => {

    const dispatch = useDispatch()
    const chartRef = useRef()
    const data = useLiveChartData(assetId, chartRef)
    const {
        trajectory,
        latestValue,
        isLive,
        hasData,
        datasets,
        labels,
        isUsdAsset,
        duration,
        changeDuration,
        isLoading,
    } = data

    const options = {
        ...defaultOptions,
        plugins: {
            ...defaultOptions.plugins,
            tooltip: {
                enabled: false,
                external: function (context) {
                    const {dataIndex} = context.tooltip?.dataPoints[0]
                    dispatch(setLiveChartHoverValues({
                        value: datasets[0].data[dataIndex],
                        datetime: labels[dataIndex],
                        assetId,
                    }))
                }
            },
            eventPlugin: {
                events: ['mouseenter', 'mouseleave'],
                onMouseLeave: () => dispatch(setLiveChartHoverIsInactive()),
                onMouseEnter: () => {
                },
            },
        },
    }

    return (
        <div className='live-chart '>
            <div className={`container ${isLive ? 'is-live' : ''}`}>
                <div className='flex-area flex-vertical-center'>
                    <SideBar
                        assetId={assetId}
                        {...data}
                    />
                    <div className='chart-container'>
                        <Chart
                            className={`no-select`}
                            type='line'
                            data={data}
                            options={options}
                            ref={chartRef}
                        />
                    </div>
                </div>
                {hasData &&
                <div className={`latest-value mobile flex-vertical-center ${trajectory}`}>
                    {isLive && <CircleIcon className={`live-indicator`}/>}
                    <Counter
                        prefix={isUsdAsset ? '$' : 'kr'}
                        amount={latestValue}
                        decimals={DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL}
                        noColor={true}
                    />
                </div>
                }
                {/*{!hasData && !isLoading &&*/}
                {/*<div className='market-closed mid-position'>*/}
                {/*    <div className='text'>*/}
                {/*        <h4>*/}
                {/*            No live data*/}
                {/*        </h4>*/}
                {/*        <Counter*/}
                {/*            prefix={isUsdAsset ? '$' : 'kr'}*/}
                {/*            amount={latestValue}*/}
                {/*            decimals={DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL}*/}
                {/*            noColor={true}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*}*/}
                {(isLoading || !hasData) &&
                <div className='loader-wrapper mid-position'>
                    <LoaderCircle/>
                </div>
                }
                <div className='durations'>
                    {durations.map(d =>
                        <button
                            key={d}
                            onClick={() => changeDuration(d)}
                            className={d === duration ? 'is-active' : ''}
                        >
                            {d > 99 ?
                                <>{d / 24}<span>d</span></>
                                :
                                <>{d}<span>h</span></>
                            }

                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}